<template>
  <FormBlock>
    <YesNoRadio v-model="lastTravel.traveled" :label="$tt('last_travel.traveled')" />
    <v-expand-transition>
      <div v-if="lastTravel.traveled" class="pt-4">
        <AppRow>
          <CountrySelect v-model="lastTravel.country" :label="$tt('last_travel.country')" />
        </AppRow>
        <AppRow>
          <DatePicker v-model="lastTravel.from" :label="$tt('last_travel.from')" :min="fromAndUntilMinDate" past />
          <DatePicker v-model="lastTravel.until" :label="$tt('last_travel.until')" :min="fromAndUntilMinDate" past />
        </AppRow>
      </div>
    </v-expand-transition>
  </FormBlock>
</template>

<script setup lang="ts">
import { getYearsAgoIso } from '~/helpers/date';
import type { LastTravel } from '~/types';

const lastTravel = defineModel<LastTravel>({ required: true });
const fromAndUntilMinDate = getYearsAgoIso(30);
</script>